import {setCookie} from '../../utils/setCookie'
import {useAccountPicker} from '../account-picker/useAccountPicker'

export type MetadataIdType = string | null

const COPY_BOARD_INFO_ENUM = {
  COPY_BOARD_ACCOUNT_ID: 'copyBoardAccountId',
  COPY_TEMPLATE_META_ID: 'copyTemplateMetaId',
}

function saveInfoAndOpenApplication(
  metadataId: MetadataIdType,
  accountId?: string,
  workspaceKey?: string,
) {
  if (!metadataId) {
    return
  }

  setCookie(COPY_BOARD_INFO_ENUM.COPY_TEMPLATE_META_ID, metadataId, 30)

  if (accountId) {
    setCookie(COPY_BOARD_INFO_ENUM.COPY_BOARD_ACCOUNT_ID, accountId, 30)
  }

  window.location.href = `${workspaceKey ? `/s/${workspaceKey}` : ''}/app/`
}

type UseTemplate = ReturnType<typeof useAccountPicker>

function useTemplate(
  metadataId: MetadataIdType,
  setMetadataId: React.Dispatch<React.SetStateAction<MetadataIdType>>,
): UseTemplate {
  const callback = (accountId: string | undefined, workspaceKey: string | undefined) =>
    saveInfoAndOpenApplication(metadataId, accountId, workspaceKey)

  return useAccountPicker({
    onAccountCancel: () => setMetadataId(null),
    onAccountError: () => saveInfoAndOpenApplication(metadataId),
    onAccountLoaded: callback,
    onAccountSubmited: callback,
  })
}

export default useTemplate
